import React from 'react';

import Typography from '@material-ui/core/Typography';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import LocationSearchingIcon from '@material-ui/icons/LocationSearching';

import { openReport } from '../../Utilities/openReport';

import './Instructions.scss';

export default function Instructions() {
  let textIconStyle = {
    fontSize: '0.975rem',
    position: 'relative',
    top: '3px',
  };
  let textSectionStyle = { textIndent: '1rem' };

  return (
    <div id='instructions' className='card'>
      <Typography variant='h5'>Getting Started</Typography>
      <Typography
        variant='body1'
        style={{ ...textSectionStyle, marginTop: '5%', marginBottom: '15%' }}
      >
        To get information about a State or County please click on the relevant
        location or use the search function (
        <LocationSearchingIcon style={textIconStyle} />) on the right side of
        the screen.
      </Typography>
      <Typography variant='body1' style={textSectionStyle}>
        For more information about how to use the tool, about the purpose of the
        tool, or the data and technical information of the tool please click the{' '}
        <HelpOutlineIcon style={textIconStyle} /> on the right side of the
        screen.
      </Typography>
      <Typography
        variant='body1'
        style={{ ...textSectionStyle, marginBottom: '5%', marginTop: '15%' }}
      >
        To see the report for this tool click{' '}
        <a
          onClick={openReport}
          className='report-link'
          target='_blank'
          rel='noreferrer'
        >
          here
        </a>
        .
      </Typography>
    </div>
  );
}
